
import Glass from "../../../assets/filled/Glass.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GlassIcon({ className, dataTestid = "GlassIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Glass data-testid={dataTestid} className={classes} {...rest} />
  );
}
